<template>
  <div class="app-container pb-50px">
    <el-card v-loading="loading" shadow="never">
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="站点名称" prop="site_name">
          <el-input
            v-model="form.site_name"
            style="width: 480px"
            placeholder="请输入站点名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录页标题" prop="login_title">
          <el-input
            v-model="form.login_title"
            style="width: 480px"
            placeholder="请输入登录页标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="后台标题" prop="admin_title">
          <el-input
            v-model="form.admin_title"
            style="width: 480px"
            placeholder="请输入后台左上角标题"
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">登录页展示</el-divider>
        <el-form-item label="管理端大标题" prop="admin_login_title">
          <el-input
            v-model="form.admin_login_title"
            style="width: 480px"
            placeholder="请输入管理端登录页大标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理端小标题" prop="admin_login_subtitle">
          <el-input
            v-model="form.admin_login_subtitle"
            style="width: 480px"
            placeholder="请输入管理端登录页小标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理端版权" prop="admin_login_copyright">
          <el-input
            v-model="form.admin_login_copyright"
            style="width: 600px"
            placeholder="请输入管理端登录页底部版权"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户端大标题" prop="customer_login_title">
          <el-input
            v-model="form.customer_login_title"
            style="width: 480px"
            placeholder="请输入客户登录页大标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户端小标题" prop="customer_login_subtitle">
          <el-input
            v-model="form.customer_login_subtitle"
            style="width: 480px"
            placeholder="请输入客户登录页小标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户端版权" prop="customer_login_copyright">
          <el-input
            v-model="form.customer_login_copyright"
            style="width: 600px"
            placeholder="请输入客户登录页底部版权"
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">后台展示</el-divider>
        <el-form-item label="站点Logo" prop="admin_logo">
          <div class="image-setting">
            <div class="image-setting__preview">
              <img
                v-if="form.admin_logo"
                :src="formatImageUrl(form.admin_logo)"
              />
              <i v-else class="el-icon-picture-outline"></i>
            </div>
            <div>
              <upload :multiple="false" :limit="1" @finish="onLogoUpload">
                <el-button size="small" type="primary">上传Logo</el-button>
              </upload>
              <el-button
                v-if="form.admin_logo"
                size="small"
                @click="form.admin_logo = ''"
              >
                清除
              </el-button>
              <div class="form-tips">
                建议上传正方形图片，顶部默认按 1:1 显示。
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="账号图标" prop="admin_avatar">
          <div class="image-setting">
            <div class="image-setting__preview image-setting__preview--round">
              <img
                v-if="form.admin_avatar"
                :src="formatImageUrl(form.admin_avatar)"
              />
              <i v-else class="el-icon-user-solid"></i>
            </div>
            <div>
              <upload :multiple="false" :limit="1" @finish="onAvatarUpload">
                <el-button size="small" type="primary">上传账号图标</el-button>
              </upload>
              <el-button
                v-if="form.admin_avatar"
                size="small"
                @click="form.admin_avatar = ''"
              >
                清除
              </el-button>
              <div class="form-tips">
                建议上传正方形图片，右上角按圆形头像显示。
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="过滤关键字" prop="mask_keyword">
          <el-input
            type="textarea"
            rows="5"
            style="width: 600px"
            v-model="form.mask_keyword"
            placeholder="请输入过滤关键字"
          ></el-input>
          <div class="form-tips">
            过滤关键字用英文逗号分隔，如：关键词1,关键词2
          </div>
        </el-form-item>
        <el-divider content-position="left">IP 位置异步解析</el-divider>
        <el-form-item label="位置解析">
          <el-switch
            v-model="form.geo.enabled"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <div class="form-tips">
            关闭后新线索无法完成位置前置检查，因此不会自动转发。
          </div>
        </el-form-item>
        <el-form-item label="本机IP测试放行">
          <el-switch
            v-model="form.geo.allow_loopback_bypass"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <div class="form-tips">
            开启后，127.0.0.1 和 ::1
            不调用位置服务，直接继续关键词检查和邮件转发；其他内网IP仍不放行。
          </div>
        </el-form-item>
        <el-form-item label="IPWHOIS">
          <el-switch
            v-model="form.geo.ipwhois_enabled"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="inline-label">超时</span>
          <el-input-number
            v-model="form.geo.ipwhois_timeout"
            :min="1"
            :max="10"
            controls-position="right"
          ></el-input-number>
          <span>秒</span>
          <span class="inline-label">失败重试</span>
          <el-input-number
            v-model="form.geo.ipwhois_retry"
            :min="0"
            :max="2"
            controls-position="right"
          ></el-input-number>
          <span>次</span>
        </el-form-item>
        <el-form-item label="结果缓存">
          <el-input-number
            v-model="form.geo.cache_days"
            :min="1"
            :max="90"
            controls-position="right"
          ></el-input-number>
          <span>天</span>
        </el-form-item>
        <el-form-item label="Ipregistry 兜底">
          <el-switch
            v-model="form.geo.ipregistry_enabled"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="inline-label">超时</span>
          <el-input-number
            v-model="form.geo.ipregistry_timeout"
            :min="1"
            :max="10"
            controls-position="right"
          ></el-input-number>
          <span>秒</span>
          <div class="form-tips">
            默认关闭。仅在 IPWHOIS 无法取得完整结果时调用一次。
          </div>
        </el-form-item>
        <el-form-item label="Ipregistry Key">
          <el-input
            v-model="form.geo.ipregistry_key"
            style="width: 480px"
            type="password"
            show-password
            autocomplete="new-password"
            :placeholder="geoKeyPlaceholder"
          ></el-input>
          <el-checkbox
            v-if="form.geo.ipregistry_key_configured"
            v-model="form.geo.clear_ipregistry_key"
          >
            清除已保存 Key
          </el-checkbox>
          <div class="form-tips">
            Key 只在后端加密保存，页面不会回显。环境变量 IPREGISTRY_API_KEY
            优先级更高。
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <footer-wrap v-if="$hasPermission('setting.system', 'edit')">
      <el-button type="primary" size="small" @click="onSubmit">
        保 存
      </el-button>
    </footer-wrap>
  </div>
</template>

<script>
import FooterWrap from "@/components/footer-wrap/index.vue";
import Upload from "@/components/upload/index.vue";

import { apiGetSystem, apiSetSystem } from "@/api/setting";
import { refreshPageTitle, setAppTitle } from "@/utils/app-title";

export default {
  components: {
    FooterWrap,
    Upload,
  },
  data() {
    return {
      loading: false,
      form: {
        site_name: "",
        login_title: "",
        admin_title: "",
        admin_login_title: "",
        admin_login_subtitle: "",
        admin_login_copyright: "",
        customer_login_title: "",
        customer_login_subtitle: "",
        customer_login_copyright: "",
        admin_logo: "",
        admin_avatar: "",
        mask_keyword: "",
        geo: {
          enabled: 1,
          ipwhois_enabled: 1,
          ipwhois_timeout: 2,
          ipwhois_retry: 1,
          ipregistry_enabled: 0,
          ipregistry_timeout: 2,
          ipregistry_key: "",
          ipregistry_key_configured: 0,
          ipregistry_env_configured: 0,
          clear_ipregistry_key: false,
          cache_days: 30,
          allow_loopback_bypass: 0,
        },
      },
      rules: {},
    };
  },
  created() {
    this.getSystem();
  },
  computed: {
    geoKeyPlaceholder() {
      if (this.form.geo.ipregistry_env_configured) return "已通过环境变量配置";
      if (this.form.geo.ipregistry_key_configured)
        return "已保存，留空表示不修改";
      return "未配置";
    },
  },
  methods: {
    getSystem() {
      this.loading = true;
      apiGetSystem().then((resp) => {
        this.form.site_name = resp.site_name;
        this.form.login_title = resp.login_title || resp.site_name;
        this.form.admin_title = resp.admin_title || resp.site_name;
        this.form.admin_login_title = resp.admin_login_title || "管理员登录";
        this.form.admin_login_subtitle =
          resp.admin_login_subtitle || "欢迎登录管理后台";
        this.form.admin_login_copyright =
          resp.admin_login_copyright || "© 2026 外贸线索与SEO管理系统";
        this.form.customer_login_title =
          resp.customer_login_title || "客户登录";
        this.form.customer_login_subtitle =
          resp.customer_login_subtitle || "登录后查看网站数据";
        this.form.customer_login_copyright =
          resp.customer_login_copyright || "© 2026 独立站数据中心";
        this.form.admin_logo = resp.admin_logo || "";
        this.form.admin_avatar = resp.admin_avatar || "";
        this.form.mask_keyword = resp.mask_keyword;
        this.form.geo = {
          ...this.form.geo,
          ...(resp.geo || {}),
          ipregistry_key: "",
          clear_ipregistry_key: false,
        };
        this.loading = false;
      });
    },
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        apiSetSystem({
          site_name: this.form.site_name,
          login_title: this.form.login_title,
          admin_title: this.form.admin_title,
          admin_login_title: this.form.admin_login_title,
          admin_login_subtitle: this.form.admin_login_subtitle,
          admin_login_copyright: this.form.admin_login_copyright,
          customer_login_title: this.form.customer_login_title,
          customer_login_subtitle: this.form.customer_login_subtitle,
          customer_login_copyright: this.form.customer_login_copyright,
          admin_logo: this.form.admin_logo,
          admin_avatar: this.form.admin_avatar,
          mask_keyword: this.form.mask_keyword,
          geo: { ...this.form.geo },
        }).then(() => {
          setAppTitle(this.form);
          refreshPageTitle(this.$route.meta?.title);
          this.$message({
            type: "success",
            message: "保存成功！",
          });
          this.getSystem();
        });
      });
    },
    onLogoUpload(file) {
      this.form.admin_logo = file.url;
    },
    onAvatarUpload(file) {
      this.form.admin_avatar = file.url;
    },
    formatImageUrl(url) {
      if (!url) return "";
      if (url.indexOf("uploads/") === 0) {
        return `/${url.replace(/^uploads\//, "upload/")}`;
      }
      if (/^https?:\/\//.test(url) || url.indexOf("/") === 0) {
        return url;
      }
      return `/${url}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-setting {
  display: flex;
  align-items: center;
  gap: 14px;

  &__preview {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: #9ca3af;
    font-size: 22px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    &--round {
      border-radius: 50%;

      img {
        object-fit: cover;
      }
    }
  }
}

.inline-label {
  margin-left: 18px;
  margin-right: 8px;
}
</style>
